import { inventoryProductService } from "../../../../../Api/Services/InventoryService/inventoryProduct";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";
import { ICreateInventoryProductResponse, IInventoryProductPayload } from "../../types";

export const updateInventoryProduct = createServiceAsyncThunk<
  ICreateInventoryProductResponse,
  { id: number; formData: FormData }
>(
  ACTION_NAMES.UPDATE_INVENTORY_PRODUCT,
  ({ id, formData }) => inventoryProductService.updateInventoryProduct(id, formData),
  ERROR_MESSAGES.UPDATE_INVENTORY_PRODUCT_FAILURE
);

const updateInventoryProductSlice = createGenericSlice<
  ICreateInventoryProductResponse,
  { id: number; formData: FormData }
>(
  SLICE_NAMES.UPDATE_INVENTORY_PRODUCT_SLICE,
  updateInventoryProduct
);

export const {
  clearError: clearUpdateInventoryProductError,
  clearSuccessMessage: clearUpdateInventoryProductSuccessMessage,
} = updateInventoryProductSlice.actions;

export default updateInventoryProductSlice.reducer;
